import React from 'react';
import * as yup from 'yup';
import { GladlyAvailabilityGate } from '@web/components/GladlyAvailabilityGate';
import { CMSBlok } from '../CMSBlok';

export const component = GladlyAvailabilityGate;

export const schema = yup
  .object({
    blocks: yup.array(yup.object()),
  })
  .transform(value => ({
    blocks: value.blocks?.map(content => (
      <CMSBlok key={content._uid} content={content} />
    )),
  }));
